<template>
  <div class="empty-state">
    <div class="content">
      <div class="flex-center-container">
        <img src="../assets/img-hole.png" />
      </div>
      <div class="quote text-h5">
        "A good golfer has the determination to win and the patience to wait for the breaks."
      </div>
      <div class="quoter text-h6">— Gary Player —</div>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty-state',
  props: {
    message: {
      type: String,
      default: 'This area seems to be empty. Check back soon.',
    },
  },

  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped>
.empty-state {
  display: flex;
  justify-content: center;
}

.content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.quote {
  font-style: italic;
  margin-top: 32px;
}

.quoter {
  margin-top: 20px;
}

img {
  width: 110px;
}

p {
  margin-top: 48px;
  font-size: 20px;
}

.flex-center-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
